import React from 'react'
import { WhenModelValue } from '@morningtrain/react-resources'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'
import {Env} from "@morningtrain/helpers";

export default function ShiftSmartviewReadView () {
  const hasClosingType = Env.get('globals.has_closing_type');

  return (
    <>
      {
        hasClosingType === 1 ?
        <WhenModelValue name='closing_type'>
          <UI.DisplayWithTitle className='mt-2' title={<Translation name='fields.closing_type.label' />}>
            <Displays.Enum name='closing_type' enum='closing_type' />
          </UI.DisplayWithTitle>
        </WhenModelValue> : false
      }
      <WhenModelValue name='note'>
        <UI.DisplayWithTitle className='mt-2' title={<Translation name='fields.shift_comment.label' />}>
          <Displays.Text name='note' />
        </UI.DisplayWithTitle>
      </WhenModelValue>
    </>
  )
}
